<div class="usuarios-container">
  <!-- Header -->
  <div class="page-header">
    <div class="header-content">
      <h1 class="page-title">
        <i class="fas fa-users-cog"></i> Gestión de Usuarios
      </h1>
      <button class="btn btn-primary btn-nuevo" (click)="createNewUser()">
        <i class="fas fa-plus"></i> Nuevo Usuario
      </button>
    </div>
  </div>

  <!-- Statistics Cards -->
  <div class="statistics-section" *ngIf="statistics">
    <div class="stat-card">
      <div class="stat-icon stat-icon-total">
        <i class="fas fa-users"></i>
      </div>
      <div class="stat-content">
        <div class="stat-value">{{ statistics.total }}</div>
        <div class="stat-label">Total</div>
      </div>
    </div>
    
    <div class="stat-card">
      <div class="stat-icon stat-icon-active">
        <i class="fas fa-user-check"></i>
      </div>
      <div class="stat-content">
        <div class="stat-value">{{ statistics.active }}</div>
        <div class="stat-label">Activos</div>
      </div>
    </div>
    
    <div class="stat-card">
      <div class="stat-icon stat-icon-inactive">
        <i class="fas fa-user-slash"></i>
      </div>
      <div class="stat-content">
        <div class="stat-value">{{ statistics.inactive }}</div>
        <div class="stat-label">Inactivos</div>
      </div>
    </div>
    
    <div class="stat-card" *ngIf="statistics.byRole['admin']">
      <div class="stat-icon stat-icon-admin">
        <i class="fas fa-user-shield"></i>
      </div>
      <div class="stat-content">
        <div class="stat-value">{{ statistics.byRole['admin'] || 0 }}</div>
        <div class="stat-label">Administradores</div>
      </div>
    </div>
  </div>

  <!-- Filters Section -->
  <div class="filters-section card">
    <div class="card-header">
      <h3 class="card-title">
        <i class="fas fa-filter"></i> Filtros de Búsqueda
      </h3>
    </div>
    <div class="card-body">
      <div class="filters-grid">
        <!-- Search input -->
        <div class="filter-group">
          <label for="search">
            <i class="fas fa-search"></i> Buscar
          </label>
          <input 
            type="text" 
            id="search"
            class="form-control"
            placeholder="Usuario, email o nro libreta..."
            [(ngModel)]="searchTerm"
            (keyup.enter)="applyFilters()">
        </div>

        <!-- Role filter -->
        <div class="filter-group">
          <label for="role">
            <i class="fas fa-shield-alt"></i> Rol
          </label>
          <select 
            id="role"
            class="form-control"
            [(ngModel)]="selectedRole"
            (change)="applyFilters()">
            <option *ngFor="let role of roles" [value]="role.value">
              {{ role.label }}
            </option>
          </select>
        </div>

        <!-- Active filter -->
        <div class="filter-group filter-checkbox">
          <label>
            <input 
              type="checkbox"
              [(ngModel)]="showInactive"
              (change)="applyFilters()">
            <span>Mostrar inactivos</span>
          </label>
        </div>

        <!-- Action buttons -->
        <div class="filter-actions">
          <button class="btn btn-primary" (click)="applyFilters()">
            <i class="fas fa-search"></i> Buscar
          </button>
          <button class="btn btn-secondary" (click)="clearFilters()">
            <i class="fas fa-times"></i> Limpiar
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Results Info -->
  <div class="results-info" *ngIf="!loading">
    <p>
      <i class="fas fa-info-circle"></i>
      Mostrando {{ filteredUsers.length }} de {{ totalUsers }} usuarios
      <span *ngIf="searchTerm || selectedRole || showInactive"> (filtrado)</span>
    </p>
  </div>

  <!-- Loading State -->
  <div class="loading-state" *ngIf="loading">
    <i class="fas fa-spinner fa-spin"></i>
    <p>Cargando usuarios...</p>
  </div>

  <!-- Error State -->
  <div class="alert alert-danger" *ngIf="error && !loading">
    <i class="fas fa-exclamation-triangle"></i>
    {{ error }}
  </div>

  <!-- Users Table -->
  <div class="table-container card" *ngIf="!loading && !error">
    <div class="table-responsive">
      <table class="usuarios-table">
        <thead>
          <tr>
            <th>Usuario</th>
            <th>Email</th>
            <th>Rol</th>
            <th>Nro Libreta</th>
            <th>Estado</th>
            <th>Creado</th>
            <th>Último acceso</th>
            <th class="actions-column">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let user of filteredUsers" [class.inactive-row]="!user.activo">
            <td class="username-cell">
              <i class="fas fa-user-circle"></i>
              <strong>{{ user.username }}</strong>
            </td>
            <td>{{ user.email }}</td>
            <td>
              <span class="badge" [ngClass]="getRoleBadgeClass(user.role)">
                {{ getRoleDisplay(user.role) }}
              </span>
            </td>
            <td class="text-center">
              <span *ngIf="user.nroLibreta" class="badge badge-info">
                {{ user.nroLibreta }}
              </span>
              <span *ngIf="!user.nroLibreta" class="text-muted">-</span>
            </td>
            <td>
              <span class="status-badge" [class.status-active]="user.activo" [class.status-inactive]="!user.activo">
                <i class="fas" [class.fa-check-circle]="user.activo" [class.fa-times-circle]="!user.activo"></i>
                {{ user.activo ? 'Activo' : 'Inactivo' }}
              </span>
            </td>
            <td class="text-muted">{{ formatCreatedDate(user.createdAt) }}</td>
            <td class="text-muted">{{ formatDate(user.lastLogin) }}</td>
            <td class="actions-column">
              <div class="action-buttons">
                <button 
                  class="btn btn-sm btn-action btn-edit"
                  (click)="editUser(user)"
                  title="Editar usuario">
                  <i class="fas fa-edit"></i>
                </button>

                <button 
                  *ngIf="user.activo"
                  class="btn btn-sm btn-action btn-reset-password"
                  (click)="resetUserPassword(user)"
                  title="Resetear contraseña">
                  <i class="fas fa-key"></i>
                </button>
                
                <button 
                  *ngIf="user.activo"
                  class="btn btn-sm btn-action btn-delete"
                  (click)="deleteUser(user)"
                  title="Desactivar usuario">
                  <i class="fas fa-trash"></i>
                </button>
                
                <button 
                  *ngIf="!user.activo"
                  class="btn btn-sm btn-action btn-reactivate"
                  (click)="reactivateUser(user)"
                  title="Reactivar usuario">
                  <i class="fas fa-undo"></i>
                </button>
              </div>
            </td>
          </tr>
          
          <!-- Empty state -->
          <tr *ngIf="filteredUsers.length === 0" class="empty-row">
            <td colspan="8" class="text-center">
              <div class="empty-state">
                <i class="fas fa-users-slash"></i>
                <p>No se encontraron usuarios</p>
                <button class="btn btn-secondary" (click)="clearFilters()" *ngIf="searchTerm || selectedRole || showInactive">
                  <i class="fas fa-times"></i> Limpiar filtros
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div class="pagination-section" *ngIf="totalPages > 1">
      <div class="pagination-info">
        Página {{ currentPage }} de {{ totalPages }}
      </div>
      <div class="pagination-controls">
        <button 
          class="btn btn-sm btn-pagination"
          (click)="goToPage(1)"
          [disabled]="currentPage === 1">
          <i class="fas fa-angle-double-left"></i>
        </button>
        <button 
          class="btn btn-sm btn-pagination"
          (click)="goToPage(currentPage - 1)"
          [disabled]="currentPage === 1">
          <i class="fas fa-angle-left"></i>
        </button>
        
        <span class="pagination-pages">
          <button 
            *ngFor="let page of [].constructor(totalPages); let i = index"
            class="btn btn-sm btn-pagination"
            [class.active]="i + 1 === currentPage"
            (click)="goToPage(i + 1)"
            [hidden]="totalPages > 10 && (i + 1 < currentPage - 2 || i + 1 > currentPage + 2)">
            {{ i + 1 }}
          </button>
        </span>
        
        <button 
          class="btn btn-sm btn-pagination"
          (click)="goToPage(currentPage + 1)"
          [disabled]="currentPage === totalPages">
          <i class="fas fa-angle-right"></i>
        </button>
        <button 
          class="btn btn-sm btn-pagination"
          (click)="goToPage(totalPages)"
          [disabled]="currentPage === totalPages">
          <i class="fas fa-angle-double-right"></i>
        </button>
      </div>
    </div>
  </div>
</div>